var _defs, _path, _use, _use2, _use3, _use4, _use5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ZH_svg__svghome/circleci/project/webpack/application/basic-components/flag-icon/icons-16/ZH_svga",
    d: "M0-1L.588.809-.952-.309H.952L-.588.809z",
    fill: "#FF0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE1C25",
    d: "M0 0h30v20H0z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ZH_svg__svghome/circleci/project/webpack/application/basic-components/flag-icon/icons-16/ZH_svga",
    transform: "matrix(3 0 0 3 5 5)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ZH_svg__svghome/circleci/project/webpack/application/basic-components/flag-icon/icons-16/ZH_svga",
    transform: "rotate(23.036 .093 25.536)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ZH_svg__svghome/circleci/project/webpack/application/basic-components/flag-icon/icons-16/ZH_svga",
    transform: "rotate(45.87 1.273 16.18)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ZH_svg__svghome/circleci/project/webpack/application/basic-components/flag-icon/icons-16/ZH_svga",
    transform: "rotate(69.945 .996 12.078)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ZH_svg__svghome/circleci/project/webpack/application/basic-components/flag-icon/icons-16/ZH_svga",
    transform: "rotate(20.66 -19.689 31.932)"
  })));
}

export default SvgZh;